import type { ReactNode } from "react";
import { useController } from "react-hook-form";
import type { FieldValues, FieldPath } from "react-hook-form";
import type { Perimetre } from "models";
import InputSkeleton from "components/InputSkeleton";
import type { ControlledInput } from "utils";
import PerimetreAutoComplete from "./PerimetreAutoComplete";

interface ControlledPerimetreAutoCompleteProps<
  T extends FieldValues,
  Name extends FieldPath<T>,
> extends ControlledInput<T, Name> {
  label: string;
  perimetres?: Array<Perimetre>;
  isLoading?: boolean;
  noOptionsText?: string;
}

function ControlledPerimetreAutoComplete<T extends FieldValues, Name extends FieldPath<T>>({
  name,
  label,
  control,
  rules,
  perimetres,
  isLoading = false,
  noOptionsText,
}: Readonly<ControlledPerimetreAutoCompleteProps<T, Name>>): ReactNode {
  const {
    field: { onChange, ref, value },
    fieldState: { error },
  } = useController({ name, control, rules });

  if (isLoading) {
    return <InputSkeleton />;
  }

  return (
    <PerimetreAutoComplete
      label={label}
      perimetres={perimetres}
      onChange={onChange}
      isLoading={isLoading}
      noOptionsText={noOptionsText}
      value={value}
      error={error}
      inputRef={ref}
    />
  );
}

export default ControlledPerimetreAutoComplete;
